import { CalendarEvent } from 'mini-calendar-event-types';
import { RsvpRenderState } from '../schema/RsvpRenderState.types';

export const getCurrentRenderState = (
    calEvent: CalendarEvent,
    fetchConflictingMeetingsFinished: boolean,
    previousRenderState: RsvpRenderState
) => {
    let currentRenderState = null;

    const renderCompleteRsvp =
        calEvent?.IsRecurring || calEvent?.IsCancelled || fetchConflictingMeetingsFinished;

    /**
     * For recurring and canceled meeting invite and non-recurring meeting invite
     * which doesn't need progressive loading
     */
    if (renderCompleteRsvp) {
        currentRenderState = RsvpRenderState.CompleteRender;
    }
    // Logging PartialRsvpRendered for non-recurring meeting invites
    else if (
        previousRenderState === RsvpRenderState.ShowPlaceholder &&
        !fetchConflictingMeetingsFinished
    ) {
        currentRenderState = RsvpRenderState.PartialRender;
    }

    return currentRenderState;
};
